import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isAdmin } from '../../ducks'

const AdminGuard = ({ isAdmin, children }) => (isAdmin ? children : null)

AdminGuard.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
}

AdminGuard.defaultProps = {
  children: null,
}

const mapStateToProps = state => ({
  isAdmin: isAdmin(state.account.login.user),
})

export default connect(mapStateToProps)(AdminGuard)
